// extracted by mini-css-extract-plugin
module.exports = {"logo__wrapper":"Home_logo__wrapper__2PR-g"};